module.exports = __webpack_public_path__ + "static/media/purpose_image.b00895af.png";